export const THUMBNAIL_SIZE = 3 * Math.pow(1024, 2);
